module.exports = __webpack_public_path__ + "static/media/arrow-left.0ea04dad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/PageSection/arrow-left.svg
// module id = 85
// module chunks = 0